// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nda-block {
  max-width: 700px;
  margin: 0 auto;
  padding: 30px;
}

.nda-block h2 {
  text-align: center;
  color: #1e293b;
  margin-bottom: 10px;
}

.nda-instruction {
  text-align: center;
  color: #64748b;
  margin-bottom: 20px;
}

.nda-text-container {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  background: #f8fafc;
  margin-bottom: 16px;
}

.nda-text {
  white-space: pre-wrap;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.7;
  color: #334155;
}

.nda-scroll-hint {
  text-align: center;
  color: #f59e0b;
  font-size: 13px;
  animation: bounce 1s infinite;
}

.nda-actions {
  margin-top: 20px;
}

.nda-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  color: #1e293b;
  cursor: pointer;
  margin-bottom: 20px;
}

.nda-checkbox-label.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nda-checkbox-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: #1173d4;
}

.nda-buttons {
  display: flex;
  justify-content: center;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/NdaBlock.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC","sourcesContent":[".nda-block {\r\n  max-width: 700px;\r\n  margin: 0 auto;\r\n  padding: 30px;\r\n}\r\n\r\n.nda-block h2 {\r\n  text-align: center;\r\n  color: #1e293b;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.nda-instruction {\r\n  text-align: center;\r\n  color: #64748b;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.nda-text-container {\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  background: #f8fafc;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.nda-text {\r\n  white-space: pre-wrap;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  line-height: 1.7;\r\n  color: #334155;\r\n}\r\n\r\n.nda-scroll-hint {\r\n  text-align: center;\r\n  color: #f59e0b;\r\n  font-size: 13px;\r\n  animation: bounce 1s infinite;\r\n}\r\n\r\n.nda-actions {\r\n  margin-top: 20px;\r\n}\r\n\r\n.nda-checkbox-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 15px;\r\n  color: #1e293b;\r\n  cursor: pointer;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.nda-checkbox-label.disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.nda-checkbox-label input[type=\"checkbox\"] {\r\n  width: 20px;\r\n  height: 20px;\r\n  accent-color: #1173d4;\r\n}\r\n\r\n.nda-buttons {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n@keyframes bounce {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-5px); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
